import React from 'react';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const statusTone = (s) => {
  const v = (s || '').toString().toUpperCase();
  if (v === 'POST') return { bg: '#e6f7ee', fg: '#15803d', bd: '#16a34a' };
  if (v === 'ENTER') return { bg: '#fff7e6', fg: '#b45309', bd: '#f59e0b' };
  return { bg: '#eef2f7', fg: '#475569', bd: '#94a3b8' };
};

const Row = ({ label, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, py: 0.2, minWidth: 0 }}>
    <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', minWidth: 74, flexShrink: 0 }}>
      {label}
    </Typography>
    <Typography
      title={value || ''}
      sx={{
        fontSize: 13,
        fontWeight: 600,
        color: '#1a2a3a',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize'
      }}>
      {value || '—'}
    </Typography>
  </Box>
);

export default function VanReceiveCard({
  xVanTransId,
  xVendor,
  xBuyer,
  xTruck,
  xEditVan,
  xDriver,
  xPhone,
  xDate,
  xLocation,
  xStatus,
  xSlaughterhouse,
  fVanModal
}) {
  const tone = statusTone(xStatus);
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        border: '1px solid #e6ebf2',
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
        cursor: 'pointer',
        transition: 'box-shadow .15s, transform .15s',
        '&:hover': { boxShadow: '0 4px 14px rgba(15,23,42,0.12)', transform: 'translateY(-1px)' }
      }}>
      {/* header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0d73bb 0%, #0a5c96 100%)',
          color: '#fff',
          px: 1.5,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
        <LocalShippingOutlinedIcon sx={{ fontSize: 18, opacity: 0.9 }} />
        <Typography sx={{ fontSize: 15, fontWeight: 700, flex: 1, letterSpacing: 0.3, color: '#fff' }}>
          {xVanTransId}
        </Typography>
        <Chip
          label={(xStatus || '').toString().toUpperCase()}
          size="small"
          sx={{
            height: 20,
            fontSize: 10,
            fontWeight: 700,
            color: tone.fg,
            bgcolor: tone.bg,
            border: `1px solid ${tone.bd}`
          }}
        />
        {xEditVan && (
          <IconButton size="small" onClick={fVanModal} sx={{ color: '#fff', p: 0.25 }}>
            <EditIcon sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </Box>

      {/* vendor */}
      <Box sx={{ px: 1.5, pt: 1 }}>
        <Typography
          title={xVendor || ''}
          sx={{
            fontSize: 14,
            fontWeight: 700,
            color: '#0d73bb',
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
          {xVendor || '—'}
        </Typography>
      </Box>

      {/* details */}
      <Box sx={{ px: 1.5, py: 1 }}>
        <Row label="Buyer" value={xBuyer} />
        <Row label="Truck" value={xTruck} />
        <Row label="Driver" value={xDriver} />
        <Row label="Phone" value={xPhone} />
        <Row label="Date" value={xDate} />
        <Row label="Location" value={xLocation} />
        <Row label="Slaughter" value={xSlaughterhouse} />
      </Box>
    </Box>
  );
}
